<script setup>
import { computed, ref, onMounted } from "vue";

const props = defineProps({
  name: { type: String, required: true },
  ext: { type: String, default: "svg" },
});

const theme = ref(document.documentElement.getAttribute("data-theme"));

const images = require.context(
  "@/assets/images/",
  false,
  /\.(svg|png|jpe?g|webp)$/,
);

const updateTheme = () => {
  theme.value = document.documentElement.getAttribute("data-theme");
};

onMounted(() => {
  window.addEventListener("theme-change", updateTheme);
});

const iconSrc = computed(() => {
  const suffix = theme.value?.toLowerCase() === "dark" ? "Dark" : "Light";
  const fileName = `${props.name}${suffix}.${props.ext}`;

  // 1. Intentar desde assets (bundler)
  try {
    return images(`./${fileName}`);
  } catch (e) {
    // 2. Fallback a public
    return `/img/${fileName}`;
  }
});
</script>

<template>
  <img :src="iconSrc" v-bind="$attrs" />
</template>
